/**
 * Kanban fluxo-oportunidades V2: cards por fase via AJAX (paginação 15 + scroll infinito + totais).
 * Toda lógica específica do V2 fica aqui; oportunidades.js permanece genérico.
 * Corrige totais do cabeçalho via AJAX após somaOportunidades (só cards visíveis) e após mover fase.
 */
Eloca.behaviors.fluxoOportunidades = function (context) {
    const $kanban = $("#kanban", context);
    if (!$kanban.length || !$kanban.data("kanban-v2")) {
        return;
    }

    const urlTemplate = $kanban.data("fase-oportunidades-url-template");
    const totaisUrl = $kanban.data("kanban-totais-url");
    const colunasUrl = $kanban.data("kanban-colunas-url");
    let faseIds = [];
    try {
        const raw = $kanban.attr("data-kanban-fase-ids");
        faseIds = raw ? JSON.parse(raw) : [];
    } catch {
        faseIds = [];
    }
    if (!Array.isArray(faseIds)) {
        faseIds = [];
    }

    const $filtroForm = $(
        "form.kanban-filters.js-form-filtro-oportunidades",
        context,
    );

    if (!urlTemplate || !$filtroForm.length) {
        return;
    }

    const PAGE_SIZE = 15;
    const SCROLL_THRESHOLD_PX = 100;
    const stateMap = new Map();
    let lastColunasRes = null;

    function formatCurrency(v) {
        const n = Number(v) || 0;
        if (typeof numeral !== "undefined") {
            return numeral(n).format("$ 0,0.00");
        }
        return n.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
    }

    function serializeFilters() {
        return $filtroForm.serialize();
    }

    window.fluxoKanbanV2SerializeFilters = function () {
        return serializeFilters() + "&apply_kanban_filters=1";
    };

    function applyTotaisFromServer(res) {
        const raw = (res && res.totais) || (res && res.fases) || {};
        const first = Object.values(raw)[0];
        if (first && first.html != null && first.valor_total == null) {
            return;
        }
        const fases = raw;
        $(".js-fase", $kanban).each(function () {
            const $fase = $(this);
            const id = String($fase.data("id"));
            const t = fases[id] || { count: 0, valor_total: 0, mensagens_nao_lidas: 0 };
            const q = t.count != null ? t.count : 0;
            const v = t.valor_total != null ? t.valor_total : 0;
            const m = t.mensagens_nao_lidas != null ? t.mensagens_nao_lidas : 0;
            const $qty = $(".js-quantidade-oportunidades-fase", $fase);
            $qty.text(`${q} oportunidades`);
            $qty.attr("data-count-fase", String(q));
            $(".js-total-oportunidades-fase", $fase).text(formatCurrency(v));

            const $naoLidas = $(".js-total-mensagens-fase", $fase);
            if (m > 0) {
                $naoLidas.html(`<span class="mensagem-nao-lida">${m}</span>`);
            } else {
                $naoLidas.empty();
            }
        });
    }

    function loadTotais() {
        if (!totaisUrl || faseIds.length === 0) {
            return;
        }
        $.ajax({
            url: totaisUrl,
            type: "get",
            dataType: "json",
            data:
                serializeFilters() +
                "&fase_ids=" +
                encodeURIComponent(JSON.stringify(faseIds)),
            xhrFields: { withCredentials: true },
            success: function (res) {
                applyTotaisFromServer(res);
            },
        });
    }

    function bindScroll($fase, $scrollPane, $ul, url) {
        const faseId = $fase.data("id");
        $scrollPane.on("scroll.kanbanV2", function () {
            const st = stateMap.get(faseId);
            if (!st || st.loadingMore || !st.hasMore) {
                return;
            }
            const el = this;
            if (
                el.scrollTop + el.clientHeight >=
                el.scrollHeight - SCROLL_THRESHOLD_PX
            ) {
                fetchPage($fase, $ul, $scrollPane, url, false);
            }
        });
    }

    function scrollLoaderEl($fase) {
        return $fase.find(".js-kanban-col-scroll-loader");
    }

    /**
     * Não lidas primeiro, depois por última interação (data-hora), tie-break created_at.
     * Espelha a ordem do servidor (não lidas, última interação, created_at) no DOM.
     */
    function ordenaOportunidadesKanbanV2(ctx) {
        const root = ctx || document;
        const $rootKanban = $("#kanban", root);
        if (!$rootKanban.length || !$rootKanban.data("kanban-v2")) {
            return;
        }
        if ($(".ui-sortable-helper, ul.kanban-drag-helper").length) {
            return;
        }
        $(".js-fase", $rootKanban).each(function () {
            const $ul = $(".lista-oportunidades", this)
                .not(".kanban-drag-helper")
                .first();
            if (!$ul.length) {
                return;
            }
            const sorted = $ul
                .children("li.oportunidade")
                .detach()
                .get()
                .sort(function (a, b) {
                    const $a = $(a);
                    const $b = $(b);
                    const aUnread = $a.hasClass("js-mensagem-nao-lida");
                    const bUnread = $b.hasClass("js-mensagem-nao-lida");
                    if (aUnread !== bUnread) {
                        return aUnread ? -1 : 1;
                    }
                    const aKey = String(
                        $a.data("hora") ||
                            $a.data("createdAt") ||
                            $a.data("created-at") ||
                            "",
                    );
                    const bKey = String(
                        $b.data("hora") ||
                            $b.data("createdAt") ||
                            $b.data("created-at") ||
                            "",
                    );
                    if (aKey !== bKey) {
                        return aKey > bKey ? -1 : 1;
                    }
                    const aCreated = String($a.data("created-at") || "");
                    const bCreated = String($b.data("created-at") || "");
                    if (aCreated !== bCreated) {
                        return aCreated > bCreated ? -1 : 1;
                    }
                    return 0;
                });
            $ul.append(sorted);
        });
    }

    window.fluxoKanbanV2OrdenaOportunidades = ordenaOportunidadesKanbanV2;

    function fetchPage($fase, $ul, $scrollPane, url, isInitial) {
        const faseId = $fase.data("id");
        let st = stateMap.get(faseId);
        if (!st) {
            st = {
                nextOffset: 0,
                loadingMore: false,
                hasMore: true,
                scrollBound: false,
            };
            stateMap.set(faseId, st);
        }
        if (st.loadingMore || !st.hasMore) {
            return;
        }
        st.loadingMore = true;
        if (isInitial) {
            $fase.addClass("is-kanban-initial-loading");
        } else {
            scrollLoaderEl($fase).removeClass("d-none");
        }

        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            data:
                serializeFilters() +
                "&offset=" +
                encodeURIComponent(String(st.nextOffset)) +
                "&per_page=" +
                encodeURIComponent(String(PAGE_SIZE)),
            xhrFields: { withCredentials: true },
            success: function (res) {
                if (res && res.html) {
                    const $incoming = $(res.html);
                    const $toAppend = $incoming.filter(function () {
                        const id = $(this).data("id");
                        if (id == null || id === "") {
                            return true;
                        }
                        $ul.children(`li.js-op-${id}`).remove();
                        return $(`#kanban li.js-op-${id}`).length === 0;
                    });
                    $ul.append($toAppend);
                }
                if (res && res.total != null) {
                    const totalFase = Number(res.total);
                    if (!Number.isNaN(totalFase)) {
                        $(".js-quantidade-oportunidades-fase", $fase).attr(
                            "data-count-fase",
                            String(totalFase),
                        );
                    }
                }
                const loaded =
                    res && res.loaded != null
                        ? Number(res.loaded)
                        : st.nextOffset + (res && res.returned != null
                              ? Number(res.returned)
                              : 0);
                st.nextOffset = loaded;
                st.hasMore = !!(res && res.has_more);
            },
            error: function (xhr) {
                if (isInitial) {
                    const msg =
                        xhr.responseJSON?.message ??
                        "Erro ao carregar oportunidades.";
                    $("<li>")
                        .addClass("list-group-item text-danger small")
                        .text(msg)
                        .appendTo($ul);
                }
                st.hasMore = false;
            },
            complete: function () {
                st.loadingMore = false;
                $fase.removeClass("is-kanban-initial-loading");
                scrollLoaderEl($fase).addClass("d-none");

                if (!st.scrollBound) {
                    st.scrollBound = true;
                    bindScroll($fase, $scrollPane, $ul, url);
                }

                ordenaOportunidadesKanbanV2(context);

                $(document).trigger("eloca:kanban-cards-changed");
                const idsKanban = $kanban.data("ids");
                if (idsKanban) {
                    try {
                        $(idsKanban).sortable("refresh");
                    } catch {
                        /* sortable pode não estar inicializado */
                    }
                }
            },
        });
    }

    const $fasesKanban = $(".js-fase", $kanban);
    if ($fasesKanban.length <= 0) {
        return;
    }

    function afterCardsLoaded($fase, $ul, $scrollPane, url) {
        const faseId = $fase.data("id");
        const st = stateMap.get(faseId);
        if (st && !st.scrollBound) {
            st.scrollBound = true;
            bindScroll($fase, $scrollPane, $ul, url);
        }
        $fase.removeClass("is-kanban-initial-loading");
        scrollLoaderEl($fase).addClass("d-none");
    }

    function loadColunasBoot() {
        if (!colunasUrl || faseIds.length === 0) {
            loadTotais();
            $fasesKanban.each(function () {
                const $fase = $(this);
                const faseId = $fase.data("id");
                const $scrollPane = $fase.find(".js-kanban-v2-scroll-pane");
                const $ul = $fase.find(".lista-oportunidades");
                const url = String(urlTemplate).replace(":faseId", String(faseId));
                fetchPage($fase, $ul, $scrollPane, url, true);
            });
            return;
        }

        $fasesKanban.addClass("is-kanban-initial-loading");
        $.ajax({
            url: colunasUrl,
            type: "get",
            dataType: "json",
            data:
                serializeFilters() +
                "&fase_ids=" +
                encodeURIComponent(JSON.stringify(faseIds)) +
                "&per_page=" +
                encodeURIComponent(String(PAGE_SIZE)),
            xhrFields: { withCredentials: true },
            success: function (res) {
                applyTotaisFromServer(res);
                lastColunasRes = res;
                const fases = (res && res.fases) || {};
                $fasesKanban.each(function () {
                    const $fase = $(this);
                    const faseId = $fase.data("id");
                    const $scrollPane = $fase.find(".js-kanban-v2-scroll-pane");
                    const $ul = $fase.find(".lista-oportunidades");
                    const url = String(urlTemplate).replace(
                        ":faseId",
                        String(faseId),
                    );
                    const pack = fases[String(faseId)] || {};
                    if (pack.html) {
                        $ul.append(pack.html);
                    }
                    stateMap.set(faseId, {
                        nextOffset:
                            pack.loaded != null ? Number(pack.loaded) : 0,
                        loadingMore: false,
                        hasMore: !!pack.has_more,
                        scrollBound: false,
                    });
                    afterCardsLoaded($fase, $ul, $scrollPane, url);
                });
            },
            error: function () {
                $fasesKanban.each(function () {
                    const $fase = $(this);
                    const $ul = $fase.find(".lista-oportunidades");
                    $ul.append(
                        '<li class="list-group-item text-danger small">Erro ao carregar oportunidades.</li>',
                    );
                    $fase.removeClass("is-kanban-initial-loading");
                    stateMap.set($fase.data("id"), {
                        nextOffset: 0,
                        loadingMore: false,
                        hasMore: false,
                        scrollBound: true,
                    });
                });
            },
            complete: function () {
                ordenaOportunidadesKanbanV2(context);
                $(document).trigger("eloca:kanban-cards-changed");
                if (lastColunasRes) {
                    applyTotaisFromServer(lastColunasRes);
                }
                const idsKanban = $kanban.data("ids");
                if (idsKanban) {
                    try {
                        $(idsKanban).sortable("refresh");
                    } catch {
                        /* sortable pode não estar inicializado */
                    }
                }
            },
        });
    }

    loadColunasBoot();

    $(document)
        .off("ajaxSuccess.fluxoV2Totais")
        .on("ajaxSuccess.fluxoV2Totais", function (_event, xhr, settings) {
            if (!$kanban.length || !$kanban.data("kanban-v2")) {
                return;
            }
            const reqUrl = settings && settings.url ? String(settings.url) : "";
            if (reqUrl.indexOf("oportunidades/update-fase") === -1) {
                return;
            }
            try {
                const res = typeof xhr.responseJSON !== "undefined"
                    ? xhr.responseJSON
                    : JSON.parse(xhr.responseText || "{}");
                if (res && res.error) {
                    return;
                }
            } catch (_unused) {
                // mantém loadTotais em respostas inesperadas
            }
            loadTotais();
        });
};
